import LabelIcon from "@mui/icons-material/Label";

import CollapsibleListItem from "src/components/List/CollapsibleList";
import { useCourseRelationsContext } from "src/context/CourseRelationsContext";

import AircraftTreeItem from "./AircraftTreeItem";
import CoursesList from "./CoursesList";
import PositionTreeItem from "./PositionTreeItem";
import { highlightText } from "./utils";
import type { RoleTreeItemProps } from "./types";

const RoleTreeItem = ({ nodeId, role, expandedNodeIds, searchTerm }: RoleTreeItemProps) => {
  const key = `${nodeId}/role${role.id}`;
  const actions = useCourseRelationsContext();
  const { courses, customCourses, groups, aircraft, positions } = role;
  const hasItems = Boolean(courses?.length || customCourses?.length || groups?.length || aircraft?.length || positions?.length);
  const isExpanded = expandedNodeIds?.has(key) ?? false;

  return (
    <CollapsibleListItem
      nodeId={key}
      title={highlightText(role.name, searchTerm)}
      isExpandable={hasItems}
      icon={<LabelIcon />}
      onClick={() => actions.nodeClicked(key)}
      forceExpanded={isExpanded}
    >
      <CoursesList
        nodeId={key}
        courses={courses}
        customCourses={customCourses}
        groups={groups}
        searchTerm={searchTerm}
      />
      {aircraft?.map((aircraft) => (
        <AircraftTreeItem
          key={`${key}/a${aircraft.id}`}
          aircraft={aircraft}
          nodeId={key}
          expandedNodeIds={expandedNodeIds}
          searchTerm={searchTerm}
        />
      ))}
      {positions?.map((position) => (
        <PositionTreeItem
          key={`${key}/p${position.id}`}
          position={position}
          nodeId={key}
          expandedNodeIds={expandedNodeIds}
          searchTerm={searchTerm}
        />
      ))}
    </CollapsibleListItem>
  );
};

export default RoleTreeItem;
